import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND = BACKEND_URL;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      const path = window.location.pathname;
      const publicish = ["/", "/about", "/sectors", "/process", "/membership",
        "/case-studies", "/contact", "/how-to-use", "/orla", "/auth"];
      // do not force-redirect from public pages
      if (!publicish.some((p) => path === p || path.startsWith("/case-studies") || path.startsWith("/legal"))) {
        // session cookie invalid/expired on a protected page
      }
    }
    return Promise.reject(error);
  }
);

export default api;
